import Factory from '../factory';

const schema = Factory.schema('hero-contact');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('heading').setType(String).setValue('Heading');
attributes.prop('email').setType(String).setValue('pro@fortiusclinic.com');
attributes.prop('telephoneNumber').setType(String).setValue('0203 195 2347');
attributes.prop('imgSrc').setType(String).setValue('image-placeholder-square.svg');

export default schema;
